import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const SelectionSliceFor = (entityKey) => {
    const selectionSlice = createSlice({
        name: entityKey,
        initialState,
        reducers: {
            addToSelection: (state, action) => {
                const record = action.payload;
                state[record.id] = record;
            },
            removeFromSelection: (state, action) => {
                delete state[action.payload];
            },
            clearSelection: (state) => {
                state = {};
            },
        },
    });

    return selectionSlice;
};
